var _circle, _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg620(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1992,
    cy: 9.5,
    r: 9,
    stroke: "#AEAEAE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.6992,
    y: 7,
    width: 2,
    height: 5,
    transform: "rotate(90 16.6992 7)",
    fill: "#AEAEAE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69922,
    y: 9,
    width: 2,
    height: 5,
    transform: "rotate(-90 3.69922 9)",
    fill: "#AEAEAE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.69922,
    y: 6,
    width: 2,
    height: 4,
    fill: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69922 13.5C8.69922 12.6716 9.37079 12 10.1992 12C11.0276 12 11.6992 12.6716 11.6992 13.5L11.6992 15L8.69922 15L8.69922 13.5Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg620);
export default __webpack_public_path__ + "static/media/6-20.8f90a2c252685cda781caecffee52388.svg";
export { ForwardRef as ReactComponent };